import { type FC } from 'react';

import { CarouselMainContainer } from 'shared/components/Carousel';
import { AdfoxPixelContainer } from 'shared/containers/AdfoxPixel';
import { Header } from 'shared/containers/Header';
import { Promos } from 'shared/containers/Promos';
import { MortgageCalculator } from 'shared/packages/mortgage-calculator';

import { AboutContainer } from '../About';
import { AwardsContainer } from '../Awards';
import { ContentWrapper } from '../ContentWrapper';
import { FactsContainer } from '../Facts';
import { PikHistoryContainer } from '../PikHistory';
import { PikInNumbers } from '../PikInNumbers';
import { PikProjectsContainer } from '../PikProjects';
import { RatingsContainer } from '../Ratings';
import { SeriaPlusContainer } from '../SeriaPlus';
import { EnvironmentForLifeAndBusinessContainer, ProductFeaturesOfTheQuarters } from '../SliderBlockTypeOne';

export const ApplicationContent: FC = () => {
  return (
    <div data-testid="ApplicationContent">
      <CarouselMainContainer />
      <ContentWrapper>
        <Header />
        <FactsContainer />
        <Promos />
        <PikProjectsContainer />
        <SeriaPlusContainer />
        <MortgageCalculator />
        <PikInNumbers />
        <EnvironmentForLifeAndBusinessContainer />
        <ProductFeaturesOfTheQuarters />
        <PikHistoryContainer />
        <RatingsContainer />
        <AwardsContainer />
        <AboutContainer />
        <AdfoxPixelContainer />
      </ContentWrapper>
    </div>
  );
};
